"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_autosuggest_1 = __importDefault(require("react-autosuggest"));
require("./index.scss");
const match_1 = __importDefault(require("autosuggest-highlight/match"));
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
const renderSuggestion = (suggestion, { query }) => {
    const matches = (0, match_1.default)(suggestion, query);
    const parts = (0, parse_1.default)(suggestion, matches);
    return (react_1.default.createElement("div", { className: 'suggestion-wrapper' }, parts.map((part, index) => part.highlight ? (react_1.default.createElement("span", { key: index },
        react_1.default.createElement("strong", null, part.text))) : (react_1.default.createElement("span", { key: index }, part.text)))));
};
const AutoCompleteInputForm = (props) => {
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const inputName = props.name;
    const { suggestions, onSuggestionsFetchRequested, onSuggestionsClearRequested } = props;
    const onSuggestionSelected = (event, data) => {
        setValue(inputName, data.suggestion);
    };
    const getSuggestionValue = (suggestion) => suggestion;
    const shouldRenderSuggestions = (value, reason) => value.length > 2;
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: inputName, control: control, render: ({ field: { value, onChange, onBlur, ref, name }, fieldState }) => {
            const inputProps = {
                placeholder: '',
                value: value,
                onChange: onChange,
                ref: ref,
                name: name,
                onBlur: onBlur,
                error: fieldState.error,
                'data-testid': inputName,
            };
            return (react_1.default.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: onSuggestionsFetchRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: renderSuggestion, inputProps: inputProps, onSuggestionSelected: onSuggestionSelected, shouldRenderSuggestions: shouldRenderSuggestions, highlightFirstSuggestion: true }));
        } }));
};
exports.default = AutoCompleteInputForm;
